const baseStyle = {
  w: 10,
  h: 10,
  fontSize: 'xs',
  fontWeight: 'bold',
};

export default baseStyle;
